import "../styles/HorizontalScroll.scss";
import CLink from "./CLink";

const HorizontalScroll = ({ texts, speed = 0, direction =  "right" }) => {
    return (
      <div className="inner">
        <div className="wrapper">
          <section className={`infiniteScroll ${direction}`} style={{ "--speed": `${speed}ms` }}>
            {texts.map((text, index) => (
              <div className="scrollTagContainer" key={index}>
                <CLink to={`/tags/${text.slice(1)}`} className={`scrollTag ${text.slice(1)}`}>{text}</CLink>
              </div>
            ))}
          </section>
          <section className={`infiniteScroll ${direction}`} style={{ "--speed": `${speed}ms` }}>
            {texts.map((text, index) => (
              <div className="scrollTagContainer" key={index}>
                <CLink to={`/tags/${text.slice(1)}`} className={`scrollTag ${text.slice(1)}`}>{text}</CLink>

              </div>
            ))}
          </section>
          <section className={`infiniteScroll ${direction}`} style={{ "--speed": `${speed}ms` }}>
            {texts.map((text, index) => (
              <div className="scrollTagContainer" key={index}>
                <CLink to={`/tags/${text.slice(1)}`} className={`scrollTag ${text.slice(1)}`}>{text}</CLink>

              </div>
            ))}
          </section>
        </div>
      </div>
    );
  };
  
export default HorizontalScroll;
  